<template>
  <div class="page-wrapper">
  <div class="module-card">
    <div class="module-header mb-2">
      <h2>Module list</h2>
      <button class="add-module-btn" aria-label="Add module" title="Add module" @click="openAddModule">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1V13M1 7H13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="table-scroll">
    <table class="module-table">
      <thead>
        <tr>
          <!-- <th>Module ID</th> -->
          <th>Module Code</th>
          <th>Module Name</th>
          <th>Description</th>
          <th class="text-center">Order</th>
          <th class="text-center">Status</th>
          <th class="text-center">Edit</th>
          <th class="text-center">Delete</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in modules" :key="m.id">
          <!-- <td data-label="Module ID">{{ m.moduleId }}</td> -->
          <td data-label="Module Code">{{ m.code }}</td>
          <td data-label="Module Name">{{ m.name }}</td>
          <td class="description-cell" data-label="Description">
            <span class="description-text" :class="{ expanded: isExpanded(m.id) }">{{ m.description }}</span>
            <a
              v-if="m.description && m.description.length > 80"
              class="more-less-link"
              @click="toggleDescription(m.id)"
            >{{ isExpanded(m.id) ? 'less' : 'more' }}</a>
          </td>
          <td class="center" data-label="Order">{{ m.order }}</td>
          <td class="center" data-label="Status"><span class="badge" :class="{ inactive: !m.active }">{{ m.active ? 'Active' : 'Inactive' }}</span></td>
          <td class="center" data-label="Edit"><i class="fa-solid fa-pen-to-square" @click="openEditModule(m)"></i></td>
          <td class="center" data-label="Delete"><i class="fa-solid fa-trash" @click="deleteModule(m)"></i></td>
        </tr>
      </tbody>
        <colgroup>
        <!-- <col style="width: 12%;"> -->
        <col style="width: 10%;">
        <col style="width: 14%;">
        <col style="width: 28%;">
        <col style="width: 8%;">
        <col style="width: 10%;">
        <col style="width: 9%;">
        <col style="width: 9%;">
      </colgroup>
    </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-bar" v-if="totalCount > 0">
      <span class="pagination-info">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }}
      </span>
      <div class="pagination-controls">
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === 1"
          @click="prevPage"
        >
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <span class="page-indicator">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          type="button"
          class="page-btn"
          :disabled="currentPage === totalPages"
          @click="nextPage"
        >
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Create / Edit module modal -->
    <ModuleModal
      ref="moduleModal"
      @module-created="onModuleSaved"
      @module-updated="onModuleSaved"
    />
  </div>
  </div>
</template>

<script>
import moduleListLogic from './Logs.js';
export default moduleListLogic;
</script>

